<mat-dialog-content class="mat-typography">
  <mat-tab-group>
    <mat-tab label="Details">
  <div>
    <div class="imageContainer">
      @if (user.profileImageUrl !== null && profileImage == undefined) {
        <img class="image"
          [src]="apiBase+user.profileImageUrl | secure | async" alt="">
      } @else {
        <img class="image" [src]="profileImageFile">
      }
      <button mat-mini-fab class="edit" color="buttonSuccess" (click)="imageInput.click()">
        <mat-icon matTooltip="Update">edit</mat-icon>
      </button>
      <input #imageInput hidden="true" type="file" onclick="this.value=null"
        (change)="updateUserProfileImage(imageInput.files!)" accept=".jpg,.png" />
    </div>
    <mat-form-field appearance="outline" color="primary" class="dialog-input">
      <mat-label>Full Name</mat-label>
      <input required [formControl]="nameFormControl" matInput>
      @if (validatorProperties.includes('Name')) {
        <mat-error>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" color="primary" class="dialog-input">
      <mat-label>Email Address</mat-label>
      <input type="email" disabled matInput [(ngModel)]="user.emailAddress">
    </mat-form-field>

    @if (authService.hasPermission(Permission.UsersFull)) {
      <mat-radio-group
        [(ngModel)]="userType"
        style="display: flex; justify-content: space-evenly"
        (change)="onUserTypeChange()"
        >
        <mat-radio-button color="primary" [value]="UserType.Tech">{{ UserType.Tech }}</mat-radio-button>
        <mat-radio-button color="primary" [value]="UserType.Imagery">{{ UserType.Imagery }}</mat-radio-button>
        <mat-radio-button color="primary" [value]="UserType.SkyTeam">{{ UserType.SkyTeam }}</mat-radio-button>
        <mat-radio-button color="primary" [value]="UserType.Client">{{ UserType.Client }}</mat-radio-button>
      </mat-radio-group>
      @if (userType === UserType.Tech || userType === UserType.Imagery) {
        <div style="display: flex; margin-top: 16px;">
          <mat-form-field appearance="outline" color="primary" class="dialog-input">
            <mat-label>{{pinLabel}}</mat-label>
            <input [formControl]="pinFormControl" maxlength="4" minlength="4" type="tel" matInput>
            @if (validatorProperties.includes('PinHash')) {
              <mat-error>
              </mat-error>
            }
            @if (pinFormControl.value.length < 4) {
              <mat-error>
                Pin must be 4 digits
              </mat-error>
            }
          </mat-form-field>
          <mat-checkbox color="primary" [formControl]="changePinFormControl" (change)="onChangePin()"
          matTooltip="Change Pin"></mat-checkbox>
        </div>
      }
      @if (userType === UserType.Client) {
        <div>
          <mat-form-field appearance="outline" color="primary" class="dialog-input">
            <mat-label>Users Organization</mat-label>
            <input
              type="text"
              placeholder="Pick one"
              aria-label="Client"
              matInput
              [formControl]="organizationFormControl"
              [matAutocomplete]="orgAuto"
              />
            <mat-autocomplete
              autoActiveFirstOption
              #orgAuto="matAutocomplete"
              [displayWith]="displayFn"
              >
              @for (organization of organizationFilteredOptions | async; track organization) {
                <mat-option
                  [value]="organization"
                  >
                  {{ organization.name }}
                </mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>
        </div>
      }
    }

    <form class="form-setting" [formGroup]="preferenceForm">
      <div class="preference__label">
        <mat-icon>schedule</mat-icon>
        <span>Preference settings</span>
      </div>
      <mat-form-field appearance="outline" color="primary" class="dialog-input">
        <mat-label>Timezone</mat-label>
        <input type="text" matInput formControlName="timezone"
          [matAutocomplete]="auto" (keyup)="onKey($event)">
        <mat-autocomplete #auto="matAutocomplete">
          @for (tz of timezoneListFiltered; track tz) {
            <mat-option [value]="tz.text">{{
              tz.text
            }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      <div class="inline-row">
        <div class="flex-grow-1">
          <mat-form-field
            appearance="outline"
            color="primary"
            class="dialog-input"
            >
            <mat-label>DateTime Format</mat-label>
            <mat-select formControlName="dateFormat">
              @for (el of dateTimeFormat; track el) {
                <mat-option
                  [value]="el.value"
                  >{{ el.text }}</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="full-row">
            <mat-checkbox
              class="example-margin"
              formControlName="is24H"
              color="primary"
              >
              24 hours time
            </mat-checkbox>
          </div>
        </div>
        <div>
          <mat-radio-group
            aria-label="Select an option"
            formControlName="asAgo"
            color="primary"
            >
            <mat-radio-button [value]="true">Days ago</mat-radio-button>
            <mat-radio-button [value]="false">Date/Time</mat-radio-button>
          </mat-radio-group>
        </div>
      </form>
    </div>
    </mat-tab>
    @if (authService.hasPermission(Permission.EmailLogsRead)) {
      <mat-tab label="Email history">
        <app-email-logs [recipientEmail]="user.emailAddress"></app-email-logs>
      </mat-tab>
    }
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button mat-button #create color="buttonSuccess" (click)="update()">Save</button>
  </mat-dialog-actions>